// extracted by mini-css-extract-plugin
export default {"pageRoot":"Setup_pageRoot__3vp7e","topAlert":"Setup_topAlert__3uear","icon":"Setup_icon__2OE0s","depositLink":"Setup_depositLink__3ppbu"};